import * as fontFiles from "./fonts";

import { injectGlobal } from "emotion";

export default injectGlobal`
  @font-face {
    font-family: "Canela-Medium";
    font-style: normal;
    font-weight: normal;
    src: local("Canela Medium"), local("Canela-Medium"), url(${
      fontFiles.CanelaMedium
    }) format("opentype");
  }
`;
